import { render, staticRenderFns } from "./TagPolygons.vue?vue&type=template&id=b8a15956&scoped=true"
import script from "./TagPolygons.vue?vue&type=script&lang=js"
export * from "./TagPolygons.vue?vue&type=script&lang=js"
import style0 from "./TagPolygons.vue?vue&type=style&index=0&id=b8a15956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a15956",
  null
  
)

export default component.exports